import {
  Component,
  ComponentRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import type { PropertyType } from '../../../core/models/property-type.model';
import type { Entity } from '../../../core/models/entity.model';
import type { UntypedFormGroup } from '@angular/forms';
import type { EntityEditorPropertyChangedEvent } from '../../models/entity-editor-property-changed.event';
import type { PropertyEditorInputs } from '../property-editor-inputs';
import type { ComponentType } from '@angular/cdk/overlay';

@Component({
  selector: 'app-entity-property-wrapper',
  templateUrl: './entity-property-wrapper.component.html',
  styleUrls: ['./entity-property-wrapper.component.scss'],
  standalone: false
})
export class EntityPropertyWrapperComponent implements OnInit, OnChanges {
  @ViewChild('componentContainer', { read: ViewContainerRef, static: true }) container: ViewContainerRef;

  @Input() propertyComponent: ComponentType<PropertyEditorInputs>;
  @Input() propertyType: PropertyType;
  @Input() entity: Entity;
  @Input() entityForm: UntypedFormGroup;

  @Output() propertyChange = new EventEmitter<EntityEditorPropertyChangedEvent>();

  private componentRef: ComponentRef<PropertyEditorInputs>;

  ngOnInit(): void {
    const component = this.container.createComponent(this.propertyComponent);
    component.setInput('entity', this.entity);
    component.setInput('entityForm', this.entityForm);
    component.setInput('propertyType', this.propertyType);

    component.instance.propertyChange.subscribe(this.propertyChange);

    this.componentRef = component;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.componentRef) {
      if (changes['entity']) {
        this.componentRef.setInput('entity', this.entity);
      }
      if (changes['entityForm']) {
        this.componentRef.setInput('entityForm', this.entity);
      }
      if (changes['propertyType']) {
        this.componentRef.setInput('propertyType', this.entity);
      }
    }
  }
}
